import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useNotificationTopics } from "../../../../hooks/useNotificationTopics"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { NotificationTopicGet } from "../../../models/NotificationTopic"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Topics() {
  const { notificationTopicsList, isLoadingNotificationTopics } =
    useNotificationTopics(true)

  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/notifications/topics",
    },
    { field: "application", headerName: "App" },
  ]

  const rows = notificationTopicsList.map((t: NotificationTopicGet) => ({
    id: t.id,
    name: t.name,
    application: t.application?.name ?? "—",
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/notifications/topics/create"
        feature={DimaFeatureShortNameEnum.NM}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/notificationTopics/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingNotificationTopics}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
